var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mj-validation-provider',{attrs:{"rules":_vm.rules,"name":_vm.name},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var invalid = ref.invalid;
var validated = ref.validated;
return [_c('mj-input-field',_vm._g(_vm._b({class:{ 'input-field--has-error': _vm.externalErrors.length > 0 || (validated && invalid) },attrs:{"id":_vm.name,"value":_vm.value}},'mj-input-field',_vm.$attrs,false),_vm.$listeners)),_c('mj-inline-error',{staticClass:"text-left",attrs:{"errors":errors.concat( _vm.externalErrors)}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }